export interface IUserProfileResponse {
  userGuid?: string;
  phoneToUpdate?: {
    areaCode: string;
    phone: string;
  };
  names: {
    firstName: string;
    lastName: string;
  };
  address?: {
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    addressLine4: string;
    city: string;
    state: string;
    postalCode: string;
  };
  country: {
    countryCode: string;
  };
  phoneNumbers: {
    phoneNumber: string;
    alternatePhoneNumber?: string;
    mobilePhoneNumber?: string;
  };
  emails: {
    email: string;
  };
  languages: {
    preferredLanguage: string;
  };
  nationalIdentification: {
    type: string;
    value: string;
    countryCode: string;
    subType: string;
  };
}
